import { render } from "./ModalFeedWall.vue?vue&type=template&id=c8b6bda0&scoped=true"
import script from "./ModalFeedWall.vue?vue&type=script&lang=js"
export * from "./ModalFeedWall.vue?vue&type=script&lang=js"

import "./ModalFeedWall.vue?vue&type=style&index=0&id=c8b6bda0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8b6bda0"]])

export default __exports__